export default __webpack_public_path__ + "static/media/enrichher-logo-white.634bf55b.svg";